<template>
  <div class="vertical-carousel-app" v-observe-visibility="visibilityChanged">
    <div class="container-fluid" v-if="isVisible">
      <v-row>
        <v-col cols="12">
          <div class="vertical-carousel-app__container">
            <div
              v-if="!offtitle"
              class="vertical-carousel-app__container__title"
            >
              <h3 class="tittle">
                {{ category.name }}
              </h3>
            </div>
            <div class="vertical-carousel-app__container__carousel">
              <swiper
                :modules="modules"
                :slides-per-view="slidesPerView"
                :slides-per-group="slidesPerView / 2"
                :space-between="25"
                navigation
                :pagination="false"
                :scrollbar="false"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                @reachEnd="onSwiperReachEnd"
                v-bind:key="paginatedAssets.join()"
              >
                <swiper-slide
                  v-for="(asset, i) in paginatedAssets"
                  v-bind:key="i"
                >
                  <vertical-slider-card
                    :asset="asset"
                    v-if="category['layout'] === 'small'"
                    :isTop="category['is_top'] === true"
                    :position="i + 1"
                    v-bind:key="i + 'a'"
                  />
                  <horizontal-slider-card
                    :asset="asset"
                    :progress="true"
                    v-bind:key="i + 'b'"
                    v-else-if="category['layout'] === 'continue_watching'"
                  />
                  <horizontal-slider-card :asset="asset" v-else />
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </v-col>
      </v-row>
      <hr v-if="isMobile()" class="divider mb-0" />
    </div>
  </div>
</template>

<script>
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import VerticalSliderCard from "@/components/app/partials/slider/VerticalSliderCard.vue";
import HorizontalSliderCard from "@/components/app/partials/slider/HorizontalSliderCard.vue";
import { mapState } from "pinia";
import { AssetStore } from "@/stores/assetStore";

export default {
  name: "VerticalCarouselApp",
  components: {
    HorizontalSliderCard,
    VerticalSliderCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    offtitle: {
      type: Boolean,
      default: false,
    },
    category: Object,
    default: function () {
      return null;
    },
  },
  computed: {
    ...mapState(AssetStore, ["getIds"]),
    ids() {
      return this.getIds();
    },
    mobile() {
      return this.isMobile();
    },
    slidesPerView() {
      let slides = this.$breakpoints(this.category.layout, this.currentWidth);
      let minslides = Math.ceil(slides / 1.5) + 1;
      return this.paginatedAssets.length >= slides ? 
                slides:
                (
                  this.paginatedAssets.length >= minslides ?
                  this.paginatedAssets.length:
                  minslides  
                );
    },
    paginatedAssets() {
      return this.category.movies
        .filter((id) => this.ids.includes(id))
        .slice(this.start, this.limit);
    },
  },
  mounted() {
    this.updateVisibleImageCount();
    window.addEventListener("resize", this.updateVisibleImageCount);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateVisibleImageCount);
  },
  data() {
    return {
      isVisible: false,
      limit: 80,
      start: 0,
      visibleImageCount: 4.3,
      currentWidth: 0,
    };
  },
  methods: {
    updateVisibleImageCount() {
      this.currentWidth = window.innerWidth;
      const width = window.innerWidth;

      if (width <= 1440) {
        this.visibleImageCount = 5; // Mínimo para resoluciones <= 1440px
      } else if (width <= 3840) {
        // Escala entre 1440 y 3840
        this.visibleImageCount = Math.ceil(
          5 + ((width - 1440) / (3840 - 1440)) * (14 - 5)
        );
      } else {
        this.visibleImageCount = 14; // Máximo para resoluciones >= 3840px
      }
    },
    visibilityChanged(isVisible) {
      if (!this.isVisible) {
        this.isVisible = isVisible;
      }
    },
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss">
.vertical-carousel-app {
  .tittle {
    font-weight: 400;
    @media (min-width: 768px) {
      margin: 1.5em 0;
    }
  }
  .vertical-slider-card,
  .horizontal-slider-card {
    margin: 0;
  }
}
</style>
